var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "241",
        height: "45",
        viewBox: "0 0 260 51",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M205.901 8.75758L198.625 0H198.518L191.234 8.75758H205.901Z",
          fill: "#b91c23"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M203.743 11.6279H193.284V48.5717H203.743V11.6279Z",
          fill: "#b91c23"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M236.642 11.6113H226.719V21.5791V23.0183L227.071 27.3439L218.173 11.6113H208.15V41.6209H218.058V30.8191L217.722 26.0192L226.497 41.6209H236.642V11.6113Z",
          fill: "#231F20"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M148.694 14.6127C147.218 13.5333 143.132 11.6035 137.409 11.6035H135.696H127.387V41.6213H134.908C134.908 41.6213 135.757 41.6213 136.04 41.6213C140.477 41.6213 154.501 41.6213 154.501 26.6083V26.2567V26.0114C154.501 20.312 150.515 15.8147 148.694 14.6127ZM144.249 26.8618V27.1071C144.249 32.9782 137.524 32.504 137.524 32.504V20.8599C138.779 20.8599 144.249 20.541 144.249 26.6165V26.8618Z",
          fill: "#231F20"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M260 46.1348H0V51.0001H260V46.1348Z", fill: "#b91c23" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M250.765 19.772H259.663V11.6113H240.628V41.6209H260V33.3458H250.765V30.2222H258.975V22.6503H250.765V19.772Z",
          fill: "#231F20"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M189.267 31.8985H179.352V11.6113H169.092V41.6209H189.267V31.8985Z",
          fill: "#231F20"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M122.988 11.6113H113.065V21.5791V23.0183L113.409 27.3439L104.519 11.6113H94.4883V41.6209H104.404V30.8191L104.067 26.0192L112.835 41.6209H122.988V11.6113Z",
          fill: "#231F20"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M2.9687 17.1227C0.887664 20.14 0.0078125 23.3699 0.0078125 26.7388V27.0986V27.5729C0.0078125 29.1265 0.344451 30.5739 0.803504 32.1357C1.37732 33.5748 2.05825 34.8913 3.07582 36.2078C4.45298 38.2521 6.26624 39.6912 8.32432 40.6561C10.4895 41.6128 12.54 42.0871 14.8199 42.2097H15.0494H15.1566H15.4932H15.9523C19.0279 41.9726 21.874 41.0077 24.4983 39.2088C27.2297 37.4098 29.0506 34.6542 29.8616 31.2934C30.0834 30.3285 30.5425 26.7307 30.5425 25.8884V23.8442H14.7052V30.811H19.1503C19.0432 31.645 18.6913 32.2501 18.0103 32.6099C17.2147 33.0924 16.4113 33.3377 15.6156 33.3377H15.279H14.8199C13.7947 33.0924 12.7695 32.4954 11.8514 31.4079C10.9409 30.3285 10.4819 28.7749 10.4819 26.7307C10.4819 24.5638 10.9409 23.0019 11.9661 21.7999C13.0985 20.4834 14.1313 19.8865 15.4932 19.8865C15.608 19.8865 16.6332 20.001 16.6332 20.001C17.0922 20.2381 17.6584 20.4834 18.1251 20.9659C18.6913 21.3175 19.1427 21.7999 19.4946 22.3968L28.7216 18.9216C27.2373 16.3949 25.1945 14.4815 22.9069 13.0342C20.4051 11.7177 18.2705 10.9654 15.1566 10.9981C9.89275 11.0553 5.18746 13.9255 2.9687 17.1227Z",
          fill: "#231F20"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M81.3058 11.6113H75.4911H69.906L59.9062 41.6209H70.7016L71.7269 37.7778H75.4911H79.3701L80.3953 41.6209H91.3284L81.3058 11.6113ZM75.4911 30.7046H73.4407L75.3763 20.7369H75.4911H75.6059C75.7206 21.8081 77.6563 30.5738 77.6563 30.7046H75.4911Z",
          fill: "#231F20"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M59.6086 39.3477L53.3425 29.38C55.1634 29.0202 56.5329 28.1779 57.451 26.7388C58.2467 25.2915 58.7058 23.6152 58.7058 21.9389V21.3256V20.7369C58.591 19.4122 58.2467 18.0875 57.6729 16.8855C57.1068 15.6835 56.3111 14.7268 55.5077 14.0072C54.2606 12.9196 53.0059 12.3309 51.6287 11.9711C50.2669 11.734 48.7826 11.6113 47.2983 11.6113H46.8469H34.4219V41.6209H44.4522V31.6532L46.8546 36.3386L49.4635 41.6209H61.0623L59.6086 39.3477ZM47.8721 24.6945L46.8546 25.0543C46.2807 25.0543 45.7146 25.177 45.1331 25.177H44.8041H44.4522V19.1751H45.4851H45.8217H46.166C46.3879 19.1751 46.625 19.1751 46.8546 19.2977C47.306 19.4122 47.7574 19.5348 48.2164 19.8946C48.7902 20.2544 49.1269 21.0967 49.1269 22.176C49.1269 23.6152 48.6678 24.3429 47.8721 24.6945Z",
          fill: "#231F20"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M196.344 7.86621H195.12V12.846H196.344H196.956V7.86621H196.344Z",
          fill: "#b91c23"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M201.288 7.86621H200.063V12.846H201.288H201.907V7.86621H201.288Z",
          fill: "#b91c23"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }